<template>
    <div class="container-menu-liste" v-show="states.show">
        <div class="menu-liste" v-if="states.searching">
            <div class="row">
                <div class="d-flex align-items-center">
                    <b-spinner small class="mr-2"></b-spinner>
                    Recherche en cours...
                </div>
            </div>
        </div>
        <div class="menu-liste" @mouseover="states.lock = true" @mouseout="states.lock = false" v-else>
            <div class="row" @click="clickOnMenuListe({text: elt.text, value: elt.value, data: (elt.data) ? elt.data : null})" v-for="elt in liste" :key="elt.id">{{ elt.text }}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MenuListe',
  props: [
      'liste'
  ],
  data() {
      return {
        states: {
            show: false,
            searching: true,
            lock: false
        }
      }
  },
  methods: {
      // Mode recherche : on affiche le menu, positionne le libellé d'attente, et lève le verrou pour le masquer si detection d'un blur()
      search() {
          this.states.searching = true;
          this.states.show = true;
          this.states.lock = false;
      },
      // Mode affichage : on force l'affichage du menu en ignorant le libellé d'attente
      show() {
          this.states.searching = false;
          this.states.show = true;
      },
      // Mode caché : on masque le menu, selon si le verrou est levé ou pas
      hide() {
          // On gère un lock pour éviter de fermer le menu (ceci à cause de l'évènement blur() déclenché avant le click() par le système, ce qui ferme le menu trop tôt le cas échéant lorsque l'on clique sur une ligne dans le menu puisque ça déclenche d'abord un blur...)
          if (!this.states.lock) {
            this.states.show = false;
          }
      },
      clickOnMenuListe(elt) {
          // Transmet un évènement personalisé vers le parent
          this.$emit('clickOnMenuListe', elt);
          // Lève le verrou pour fermeture du menu
          this.states.lock = false;
          this.hide();
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .container-menu-liste {
        position: relative;
        top: 0.3ex;
        z-index: 10000;
    }
    .menu-liste {
        position: absolute;
        width: 100%;
        border: 1px solid lightgray;
        border-bottom-left-radius: 0.5ex;
        border-bottom-right-radius: 0.5ex;
    }
    .row {
        margin: 0;
        padding: 0 2ex 0 2ex;
        line-height: 4ex;
        background-color: #FFF;
    }
    .row:hover {
       background-color: #EEEEEE;
       cursor: pointer;
    }
    .row:last-child {
        border-bottom-left-radius: 0.5ex;
        border-bottom-right-radius: 0.5ex;
    }
</style>



// WEBPACK FOOTER //
// src/components/MenuListe.vue